import type { MenuItem, LinkMenuItem, ExpandableMenuItem } from '@core/ui/navigation';

const createLinkItem = (id: string, label: string, href: string, external?: boolean, metadata?: { handler: string }): LinkMenuItem => ({
  id,
  type: 'link',
  label,
  href,
  external,
  metadata,
});

const createExpandableItem = (id: string, label: string, items: MenuItem[]): ExpandableMenuItem => ({
  id,
  type: 'expandable',
  label,
  items,
});

export const menuNavigationItems: MenuItem[] = [
  createLinkItem('market-insights', 'News & Insights', 'https://www.zoocasa.com/blog/', true),
  createLinkItem('newsletter', 'Newsletter', 'https://zoocasa.ac-page.com/newsletter'),
  createExpandableItem('careers', 'Careers', [
    createLinkItem('headquarters', 'Headquarters', 'https://jobs.jobvite.com/exprealty/jobs', true),
    createLinkItem('agents', 'Agents', 'https://accelerator.zoocasa.com', true),
  ]),
  createLinkItem('about-us', 'About Us', '/about-us'),
  createLinkItem('accessibility', 'Accessibility', '#', undefined, { handler: 'openAccessibilityMenu' }),
  createLinkItem('sitemap', 'Sitemap', '/sitemap'),
]; 